__turbopack_context__.v({
  "blue": "indicator-module__OBOTTq__blue",
  "face": "indicator-module__OBOTTq__face",
  "indicator": "indicator-module__OBOTTq__indicator",
  "indicatorShadow": "indicator-module__OBOTTq__indicatorShadow",
  "orange": "indicator-module__OBOTTq__orange",
  "palette": "indicator-module__OBOTTq__palette",
  "paletteActive": "indicator-module__OBOTTq__paletteActive",
  "pointerGlow": "indicator-module__OBOTTq__pointerGlow",
  "vector": "indicator-module__OBOTTq__vector",
  "vectorEnd": "indicator-module__OBOTTq__vectorEnd",
  "vectorStart": "indicator-module__OBOTTq__vectorStart",
  "white": "indicator-module__OBOTTq__white",
});
